import { render, staticRenderFns } from "./WisdomEdit.vue?vue&type=template&id=30bcb995&scoped=true"
import script from "./WisdomEdit.vue?vue&type=script&lang=js"
export * from "./WisdomEdit.vue?vue&type=script&lang=js"
import style0 from "./WisdomEdit.vue?vue&type=style&index=0&id=30bcb995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bcb995",
  null
  
)

export default component.exports